import { ctxTachograph } from '@/contexts/TachographCtx';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import TachographGenerateButton from './TachographGenerateButton';
import { TachoTabs } from './TachographPopup';
import TachographVehicleData from './TachographVehicleData';
import TachographFileNameSelector from './TachographFileNameSelector';

export default function TachographTargetTab({ activeTab }: { activeTab: TachoTabs }) {
  const { t } = useTranslation();
  const tachographCtx = useContext(ctxTachograph);

  if (!tachographCtx) return null;

  return (
    <>
      <div id="target-tachograph-data" data-qa-element-id="cehicle_selector_panel">
        <Typography variant="h6" id="report-header-h3" data-qa-element-id="vehicle_selector_panel_title">
          {t('tachograph.vehicleSelector')}
        </Typography>
        <TachographVehicleData isListView={false} />
        {tachographCtx.selectedRowIds.length > 0 && (
          <div id="target-tachograph-data-menu" data-qa-element-id="file_download_panel">
            <div className="tachograph-radio-button-conainer">
              <TachographFileNameSelector />
            </div>
            <div className="tachograph-button-conainer">
              <TachographGenerateButton activeTab={activeTab} />
              <Typography variant="helperText" className="tachograph-generate-comment">
                {t('tachograph.downloadButton.description')}
              </Typography>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
